import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Divider } from '@mui/material';
import { RequirementsAccordion } from './ManageCompliance';
import { IEngineRequirement } from 'app/models/Placement/CredOneCompliance';
import { ConditionGroups } from './ConditionGroup';

export const useComplianceCollapseStyles = makeStyles()({
  hideBorder: {
    boxShadow: 'none',
    borderColor: '#E3DFDF',
    '&:before': {
      border: 'none',
    },
  },
  conditionGroup: {
    background: '#F5F5F5',
    border: '1px solid #E7E5E5',
  },
  conditionGroupBorderHidden: {
    background: '#F5F5F5',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
});

/**
 * Component that renders the collapse requirement content in requirement table
 */
export const ComplianceCollapse = ({
  complianceItem,
  index,
}: {
  complianceItem: IEngineRequirement;
  index: number;
}) => {
  const children =
    complianceItem && complianceItem.rules?.length ? (
      <ConditionGroups conditionGroups={complianceItem.rules[0]?.conditionGroup?.conditionGroups} />
    ) : null;
  return (
    <>
      <RequirementsAccordion complianceItem={complianceItem} children={children} index={index} />
      <Divider />
    </>
  );
};
